import {NotificationService} from "../../services/NotificationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {LocationHistoryService} from "../../services/LocationHistoryService";
import {ReportAssetsModelBase} from "./ReportAssetsModelBase";

export class ReportLocationHistoryModel extends ReportAssetsModelBase{
    static $inject = ['$window','$q','FileSaver','Blob','LocationHistoryService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    constructor(public $window:Window,
                public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public locationHistoryService:LocationHistoryService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
        super();
        this.getCount();
    }
    getReportName():String{
        return "Location History Report";
    }
    getHeader():string[]{
        return ["ID", "Location Name","Asset Name", "Transaction Time", "Asset ID"];
    }
    getMyReport():ng.IPromise<any>{

        return this.locationHistoryService.getReport(false, this.name, this.location, this.assetType, this.department, this.disposalStatus, this.checkedinStatus, this.missing, this.tagType).then((data) => {
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'locationHistory.xlsx');
        })
        .catch((exc)=>{
            this.notifyService.notify("getReport err:"+exc);
        });
        return this.$q.when();
    }

    getCount():ng.IPromise<any>{
        //alert(this.location);
        return this.locationHistoryService.getReportCount(false, this.name,this.location,this.assetType,this.department,this.disposalStatus,this.checkedinStatus,this.missing,this.tagType)
            .then((data)=>{
                this.totalCount = data;
            }).catch((exc)=>{
                this.notifyService.notify("Exception in getCount-"+exc);
            });
    }

}

